<template>
  <div class="show-trove" ref="activity_scroll" @scroll="activityScroll">
    <ul class="menu">
        <li @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">PDF</li>
        <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">视频</li>
    </ul>
    <!-- pdf -->
    <product-shopping v-show="menuType == '2'" :productMaterial="productMaterial" @videoChange="videoChange"></product-shopping>
    <!-- 视频 -->
    <newProVideo v-show="menuType == '1'" :productVideo="productVideo" @videoChange="videoChange" :lineType="2"></newProVideo>
    <footerLine></footerLine>
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import productShopping from './components/product-shopping'
import newProVideo from './components/new-pro-video.vue'
import { getProBindList } from '@/api/centrifuge'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'

export default {
    components: {
        productShopping,
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            last_page: '',
            menuType: '2', // 1 -- 视频 2 -- pdf
            productMaterial: [],
            productVideo: [],
            showVideo: false,
        }
    },
    created() {
        this.getProList()
    },
    mounted() {
      document.title = this.menuType == 1 ? "讲解与宝典-视频" : "讲解与宝典-PDF";
    },
    methods: {
        handleMenu(type) {
            this.page = 1
            this.productMaterial = []
            this.productVideo = []
            this.menuType = type
            this.getProList()
            document.title = this.menuType == 1 ? "讲解与宝典-视频" : "讲解与宝典-PDF";
        },
        getProList() {
            let para = {
                module: this.menuType == "1" ? "4" : "3",
                type: this.menuType,
                page: this.page,
                cid: 0
            }
            getProBindList(para).then(res => {
                this.menuType == '1' ? this.productVideo.push(...res.data.data) : this.productMaterial.push(...res.data.data);
                this.last_page = res.data.last_page
            })
        },
        activityScroll () {
            // console.log('查看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.show-trove {
    height: 100vh;
    overflow: auto;
}
.menu {
    width: rem(343);
    height: rem(30);
    display: flex;
    justify-content: center;
    // align-items: center;
    border-radius: 4px;
    color: #6CC5DB;
    border: 1px solid #59C1D6;
    margin: rem(16) auto;
    li {
        flex: 1;
        line-height: rem(30);
        text-align: center;
    }
    .active {
        color: #fff;
        background-color: #6CC5DB;
        border-radius: 4px;
    }
}
.middle-content {
    height: rem(30);
    border-radius: 4px;
    display: flex;
    align-items: center;
    color: #9d9d9d;
    margin: 0 rem(20) rem(20) rem(20);
    padding: 0 rem(11);
    background: #f4f4f4;
    .iconfont {
        color: #9d9d9d;
    }
    .van-cell {
        padding-left: rem(8);
    }
    .input {
        background: none;
    }
}
</style>